import { render, staticRenderFns } from "./ApplicationTypeForm.vue?vue&type=template&id=7b963572&"
import script from "./ApplicationTypeForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports